export function Footer() {
  return (
    <footer className="footer footer-center p-4 bg-base-200 text-base-content">
      <div>
        <p>Site built by Jonathan Deiss. Original game by Don Eskridge</p>
      </div>
    </footer>
  )
}
